import { IGlobalSearchResultDto, ISearchResultDtoPagedCollection } from "../../../model/base/response/search-response";

export interface ISearchResultsState {
    searchResults: ISearchResultDtoPagedCollection | null;
    searchTerm: string;
    totalByType?: { [key: string]: number };
}

export const initialState: ISearchResultsState = {
    searchResults: null,
    searchTerm: '',
    totalByType: undefined
};

export enum ACTION_TYPES {
    SET_SEARCH_RESULTS = 'SET_SEARCH_RESULTS',
    SET_SEARCH_TERM = 'SET_SEARCH_TERM'
}

export const SearchResultsReducer = (state: ISearchResultsState, action: any): ISearchResultsState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.SET_SEARCH_RESULTS:
            return {
                ...state,
                searchResults: payload.results,
                searchTerm: payload.searchTerm || state.searchTerm,
                totalByType: payload.totalByType,
            };
        case ACTION_TYPES.SET_SEARCH_TERM:
            return {
                ...state,
                searchTerm: payload,
            };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
